import { useSelector } from 'react-redux';
import useLeasingValue from './useLeasingValue';

const useTotalPrice = () => {
  const { mileagePrice, colorPrice, tyresPrice, insurancePrice } = useLeasingValue();
  return (
    mileagePrice + colorPrice + tyresPrice + insurancePrice
  );
};

export default useTotalPrice;